var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.9584H6.66667C3.625 18.9584 1.875 17.2084 1.875 14.1667V5.83335C1.875 2.79169 3.625 1.04169 6.66667 1.04169H13.3333C16.375 1.04169 18.125 2.79169 18.125 5.83335V14.1667C18.125 17.2084 16.375 18.9584 13.3333 18.9584ZM6.66667 2.29169C4.28333 2.29169 3.125 3.45002 3.125 5.83335V14.1667C3.125 16.55 4.28333 17.7084 6.66667 17.7084H13.3333C15.7167 17.7084 16.875 16.55 16.875 14.1667V5.83335C16.875 3.45002 15.7167 2.29169 13.3333 2.29169H6.66667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 7.70833H13.7502C12.4835 7.70833 11.4585 6.68333 11.4585 5.41667V3.75C11.4585 3.40833 11.7418 3.125 12.0835 3.125C12.4252 3.125 12.7085 3.40833 12.7085 3.75V5.41667C12.7085 5.99167 13.1752 6.45833 13.7502 6.45833H15.4168C15.7585 6.45833 16.0418 6.74167 16.0418 7.08333C16.0418 7.425 15.7585 7.70833 15.4168 7.70833Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 11.4583H6.6665C6.32484 11.4583 6.0415 11.175 6.0415 10.8333C6.0415 10.4916 6.32484 10.2083 6.6665 10.2083H9.99984C10.3415 10.2083 10.6248 10.4916 10.6248 10.8333C10.6248 11.175 10.3415 11.4583 9.99984 11.4583Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 14.7917H6.6665C6.32484 14.7917 6.0415 14.5084 6.0415 14.1667C6.0415 13.825 6.32484 13.5417 6.6665 13.5417H13.3332C13.6748 13.5417 13.9582 13.825 13.9582 14.1667C13.9582 14.5084 13.6748 14.7917 13.3332 14.7917Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMessage);
export default __webpack_public_path__ + "static/media/text-message.6cea4e154de10c59c34271460e96f3ae.svg";
export { ForwardRef as ReactComponent };